import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import styles from "./styles/Layout/Layout.module.css"
import { HomePage } from "./pages/Home/HomePage"
import { EmployeesPage } from "./pages/Employees/EmployeesPage";
import { ChangeEmpoloyeesPage } from "./pages/Employees/ChangeEmpoloyeesPage";
import { useEffect, useState, useContext } from "react"; 
import { LoginPage } from "./pages/Login/LoginPage";
import { LeadPage } from "./pages/Lead/LeadPage";
import { OtherPage } from "./pages/Other/OtherPage";
import { VerificationPage } from "./pages/Lead/components/LeadManagement/VerificationPage";
import { TransactionsPageWrapper } from "./Layout/Transactions/TransactionsPageWrapper";
import { Deposit } from "./pages/Transactions/components/Deposit";
import { Withdrawal } from "./pages/Transactions/components/Withdrawal";
import { Bonus } from "./pages/Transactions/components/Bonus";
import { NotFoundPage } from "./components/error/NotFoundPage";
import { ProtectedRoute } from "./components/error/ProtectedRoute";
import { Info } from "./pages/Lead/components/LeadManagement/Info";
import { LeadManagementWrapper } from "./Layout/LeadManagement/LeadManagementWrapper";
import { HistoryPage } from "./pages/Lead/components/LeadManagement/HistoryPage";
import { PaymentsPage } from "./pages/Lead/components/LeadManagement/TransactionsPage";
import { DocumentationPage } from "./pages/Documentation/DocumentationPage"
import { Wrapper } from "./components/UI/Custom/Wrapper";
import { Comments } from "./pages/Lead/components/LeadManagement/Comments";
import { OpenDealsPage } from "./pages/Lead/components/LeadManagement/OpenDealsPage";
import { TradeHistoryPage } from "./pages/Lead/components/LeadManagement/TradeHistoryPage";
import { AccountPage } from "./pages/Account/AccountPage";
import { AccountAffiliatorPage } from "./pages/Account/AccountAffiliatorPage";
import {All} from "./pages/Transactions/components/All";
import { AllowedIpsPage } from "./pages/AllowedIps/AllowedIpsPage";
import { DepositMethodsPage } from "./pages/DepositMethods/DepositMethodsPage";
import { ContactUsPage } from "./pages/ContactUs/ContactUsPage";
import { LangProvider } from "./context/LangContext";
import { ThemeProvider } from "./context/ThemeContext";
import {ResolvedDepositMethodsPage} from "./pages/Lead/components/LeadManagement/ResolvedDepositMethods";
import { Layout } from "./Layout/Layout";
import { NotificationsPage } from "./pages/Notification/NotificationsPage";
import { LeadChatPage } from "./pages/Lead/components/LeadManagement/LeadChatPage";
import { TelegramNotificationsPage } from "./pages/TelegramNotifications/TelegramNotificationsPage";
import { AnalyticsPage } from "./pages/Analytics/AnalyticsPage";

export const Router = () => {
    const [tabsSelected, setTabsSelected] = useState("Deposit");
    const [isLoading, setIsLoading] = useState(true);
    const [isLogin, setIsLogin] = useState({
        isLoggedIn: false,
        userData: null
    });
    
    useEffect(() => {
        const savedLogin = localStorage.getItem('login');
        if (savedLogin) {
            const loginData = JSON.parse(savedLogin);
            setIsLogin(loginData);
        }
        setIsLoading(false);
    }, []);

    const location = useLocation();

    if (isLoading) return null;

    return (
        <ThemeProvider>
            <LangProvider>
                <Routes>
                    {!isLogin.isLoggedIn && (
                        <Route path="*" element={
                            <LoginPage
                                setIsLogin={setIsLogin}
                            />
                        } />
                    )}

                    {isLogin.isLoggedIn ? (
                        <Route 
                            element={
                                <Layout 
                                    isLogin={isLogin} 
                                    tabsSelected={tabsSelected} 
                                    setTabsSelected={setTabsSelected} 
                                    setIsLogin={setIsLogin} 
                                />
                            }
                        >
                            {isLogin.userData.userRole === "Affiliator" && (
                                <Route element={<ProtectedRoute allowedRoles={["Affiliator"]} userRole={isLogin.userData.userRole} />}>
                                    <Route path="/documentation" element={<DocumentationPage />} />
                                    <Route path="/lead" element={<LeadPage role={isLogin.userData.userRole.toLowerCase()} />} />
                                    <Route path="/" element={<HomePage />} />
                                    <Route path="/lead/change/*" element={<LeadManagementWrapper role={isLogin.userData.userRole.toLowerCase()} />}>
                                        <Route path="info/:id" element={<Info role={isLogin.userData.userRole.toLowerCase()} />} />
                                    </Route>
                                    <Route path="/account" element={<AccountAffiliatorPage />} />
                                </Route>
                            )}
                            
                            {isLogin.userData.userRole === "Admin" && (
                                <>
                                    <Route path="/" Component={HomePage} />
                                    <Route path="/employees" Component={EmployeesPage} />
                                    <Route path="/allowed-ips" Component={AllowedIpsPage} />
                                    <Route path="/deposit-methods" Component={DepositMethodsPage} />
                                    <Route path="/contact-us" Component={ContactUsPage} />
                                    <Route path="/analytics" Component={AnalyticsPage} />
                                    <Route
                                        path="/transactions/*"
                                        element={
                                            <TransactionsPageWrapper
                                                tabsSelected={tabsSelected}
                                                setTabsSelected={setTabsSelected}
                                            >
                                                <Routes>
                                                    <Route path="/all" Component={All} />
                                                    <Route path="/deposit" Component={Deposit} />
                                                    <Route path="/withdrawal" Component={Withdrawal} />
                                                    <Route path="/bonus" Component={Bonus} />
                                                </Routes>
                                            </TransactionsPageWrapper>
                                        }
                                    />
                                    <Route path="/employees/change/:id" element={<ChangeEmpoloyeesPage pathname={location.pathname} />} />
                                    <Route path="/lead" element={<LeadPage role={isLogin.userData.userRole.toLowerCase()} />} />
                                    <Route path="/lead/change/*" element={<LeadManagementWrapper role={isLogin.userData.userRole.toLowerCase()} />}>
                                        <Route path="info/:id" element={<Info role={isLogin.userData.userRole.toLowerCase()} />} />
                                        <Route path="deposit-methods-override/:id" element={<ResolvedDepositMethodsPage />} />
                                        <Route path="comments/:id" element={<Comments role={isLogin.userData.userRole.toLowerCase()} />} />
                                        <Route path="verification/:id" element={<VerificationPage />} />
                                        <Route path="transaction/:id" element={<PaymentsPage />} />
                                        <Route path="open-deals/:id" element={<OpenDealsPage />} />
                                        <Route path="trade-history/:id" element={<TradeHistoryPage />} />
                                        <Route path="history/:id" element={<HistoryPage />} />
                                        <Route path="history/:id" element={<HistoryPage />} />
                                        <Route path="chat/:id" element={<LeadChatPage />} />
                                    </Route>
                                    <Route path="/other" Component={OtherPage} />
                                    <Route path="/account" Component={AccountPage} />
                                    <Route path="/notifications" element={<NotificationsPage />} />
                                    <Route path="/telegram-notifications" element={<TelegramNotificationsPage />} />
                                </>
                            )}
                            
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                    ) : (
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    )}
                </Routes>
            </LangProvider>
        </ThemeProvider>
    );
};
